<div
    #storyFullScreen
    class="st-note-full-screen__header"
    [dir]="dir()"
    [class.disabled]="disabled()">
    @if (record()) {
        <div
            class="st-note-full-screen__header__title"
            tabindex="0">
            {{ headerLabel() }}
        </div>
        <div class="st-note-full-screen__header__actions">
            <st-status
                addEmptyOption
                [value]="record()?.PSTNoteStatus"
                [fieldName]="PSTFieldNames.PSTNoteStatus"
                [data]="record()"
                [itemType]="record()?.PSTNoteStatus?.id"
                [disabled]="disabled()"
                [statusFieldName]="PSTFieldNames.PSTNoteStatus"
                [placeholder]="globalTablesService.FieldDefsDict[PSTFieldNames?.PSTNoteStatus]?.DefaultCaption"
                [itemList]="globalTablesService.getListItemsForField(PSTFieldNames.PSTNoteStatus)"
                (changed)="updateCurrentNote({ value: $event, key: PSTFieldNames.PSTNoteStatus })" />

            @if (!record()?.isNewRecord) {
                <st-external-actions-overlay
                    st-click-stop-propagation
                    isNoteItem
                    [inFullScreen]="true"
                    [disabled]="disabled()"
                    [data]="record()"
                    [editable]="true" />
            }
        </div>
    }
</div>
<div class="st-note-full-screen__body">
    <div class="st-note-full-screen__editor-container">
        @if (loading() || !record()) {
            <st-loader
                class="st-note-full-screen__loader"
                [diameter]="200"
                [productLabel]="languageSettings().PSTWebLoadingLabel"
                [strokeWidth]="10" />
        } @else {
            <st-raw-content-editor
                [editorContent]="noteContent()"
                [disabled]="disabled()"
                (contentChange)="updateCurrentNote({ value: $event, key: PSTFieldNames.RawContent })" />
            <div class="st-note-full-screen__editor-container__footer">{{ currentStoryWordsCount() }}</div>
        }
    </div>
</div>
<div class="st-note-full-screen__footer">
    <button
        mat-button
        class="st-note-full-screen__footer__cancel-btn"
        matRipple
        [disabled]="disabled()"
        [matRippleRadius]="15"
        (click)="cancel()">
        @if (!loading()) {
            {{ languageSettings().PSTWebCancelButtonLabel }}
        } @else {
            <st-loader
                class="st-note-full-screen__footer__spinner"
                [diameter]="30"
                [strokeWidth]="5" />
        }
    </button>
    <button
        class="st-note-full-screen__footer__create-btn"
        mat-button
        [disabled]="disabled() || noteContent().length === 0"
        (click)="addOrUpdate()">
        @if (!loading()) {
            {{ saveBtnLabel() }}
        } @else {
            <st-loader
                class="st-note-full-screen__footer__spinner"
                [diameter]="30"
                [strokeWidth]="5" />
        }
    </button>
</div>
